<div class="flex flex-column gap-2 p-3 border-1 border-primary border-round-lg" data-test="ql-builder-relative-date">

    <div class="flex align-items-center gap-2">
        <i class="fa-regular fa-calendar-days text-primary"></i>
        <span class="font-semibold">Relativer Zeitraum</span>
    </div>
    <span class="text-sm text-color-secondary">
        Der Stichtag wird bei jeder Ausführung neu berechnet – z. B. „die letzten 30 Tage“ ab heute.
    </span>

    @if (!fields.length) {
        <p-message severity="info" size="small" styleClass="w-full"
                   text="Diese Entität hat keine Datumsfelder – ein relativer Zeitraum ist nicht möglich."></p-message>
    } @else {
        <div class="flex flex-wrap align-items-end gap-2">
            <div class="flex flex-column gap-1">
                <label class="text-sm font-medium" [for]="'relDateField-' + alias">Datumsfeld</label>
                <p-select [options]="fields" optionLabel="label" optionValue="value"
                          [(ngModel)]="field" [filter]="true" appendTo="body"
                          [inputId]="'relDateField-' + alias" placeholder="Datumsfeld wählen" styleClass="w-14rem"
                          data-test="ql-builder-relative-date-field"></p-select>
            </div>
            <div class="flex flex-column gap-1">
                <label class="text-sm font-medium" [for]="'relDateOperation-' + alias">Vergleich</label>
                <p-select [options]="operatorOptions" optionLabel="label" optionValue="value"
                          [(ngModel)]="operation" appendTo="body"
                          [inputId]="'relDateOperation-' + alias" styleClass="w-8rem"
                          data-test="ql-builder-relative-date-operation"></p-select>
            </div>
            <div class="flex flex-column gap-1">
                <label class="text-sm font-medium" [for]="'relDateBase-' + alias">Stichtag</label>
                <p-select [options]="baseOptions" optionLabel="label" optionValue="value"
                          [(ngModel)]="base" appendTo="body"
                          [inputId]="'relDateBase-' + alias" styleClass="w-10rem"
                          data-test="ql-builder-relative-date-base"></p-select>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-sm font-medium" [id]="'relDateDirection-' + alias">Richtung</span>
                <p-selectButton [options]="directionOptions" optionLabel="label" optionValue="value"
                                [(ngModel)]="direction" [allowEmpty]="false"
                                [ariaLabelledBy]="'relDateDirection-' + alias"
                                data-test="ql-builder-relative-date-direction"></p-selectButton>
            </div>
            <div class="flex flex-column gap-1">
                <label class="text-sm font-medium" [for]="'relDateAmount-' + alias">Anzahl</label>
                <p-inputNumber [(ngModel)]="amount" [min]="0" [max]="maxAmount" [useGrouping]="false"
                               [showButtons]="true" [inputId]="'relDateAmount-' + alias" inputStyleClass="w-5rem"
                               data-test="ql-builder-relative-date-amount"></p-inputNumber>
            </div>
            <div class="flex flex-column gap-1">
                <label class="text-sm font-medium" [for]="'relDateUnit-' + alias">Einheit</label>
                <p-select [options]="unitOptions" optionLabel="label" optionValue="value"
                          [(ngModel)]="unit" appendTo="body"
                          [inputId]="'relDateUnit-' + alias" styleClass="w-8rem"
                          data-test="ql-builder-relative-date-unit"></p-select>
            </div>
        </div>

        @if (unit === 'W') {
            <span class="text-sm text-color-secondary">
                <i class="fa-regular fa-circle-info mr-1"></i>{{ textWeeksAsDays }}
            </span>
        }

        @if (preview; as sentence) {
            <div class="flex flex-wrap align-items-center gap-2" data-test="ql-builder-relative-date-preview">
                <span class="text-sm">Vorschau:</span>
                <p-chip [label]="sentence" icon="fa-regular fa-calendar-days"></p-chip>
                <span class="text-xs text-color-secondary">{{ value }}</span>
            </div>
        } @else {
            <span class="text-sm text-color-secondary">
                Bitte Datumsfeld und eine Anzahl zwischen 0 und {{ maxAmount }} wählen.
            </span>
        }
    }

    <div class="flex justify-content-end gap-2">
        <p-button label="Abbrechen" severity="secondary" [text]="true" (onClick)="onCancel()"
                  data-test="ql-builder-relative-date-cancel"></p-button>
        <p-button label="Übernehmen" icon="fa-regular fa-check" [disabled]="!applicable"
                  data-test="ql-builder-relative-date-apply"
                  (onClick)="onApply()"></p-button>
    </div>
</div>
